import React, { useEffect, useState } from 'react';

const CollectionBadge = ({ article }) => {
  const [collectionData, setCollectionData] = useState({})

  useEffect(() => {
    fetchCollectionData()
  }, [])

  const fetchCollectionData = () => {
    $.ajax({
      type: "GET",
      url: `/articles/${article.id}/approved_collection`,
      dataType: "JSON",
      success: function(res) {
        if(res.approved_collection) {
          setCollectionData({
            title: res.approved_collection.title,
            logo: res.approved_collection.banner_image,
            collection_path: res.approved_collection.collection_path
          })
        }
      }
    })
  }

  return (
    <>
      {collectionData.title &&
        <>
          <hr/>
          <div className='row small collection-banner'>
            <a href={collectionData.collection_path}>
              <img
                src={collectionData.logo}
                className='collection-logo'/>
            </a>
            <div className='collection-name-container'>
              <a href={collectionData.collection_path}>
              <span className='collection-name'>
                Published in the {collectionData.title} collection
              </span>
              </a>
            </div>
          </div>
        </>
      }
    </>
  )
}

export default CollectionBadge